/**
 * Offer collection countdown timer
 */
(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdown(root) {
    var endDate = root.dataset.endDate;
    var endTime = root.dataset.endTime || '23:59';
    if (!endDate) return;

    var endMs = new Date(endDate + 'T' + endTime + ':00').getTime();
    if (Number.isNaN(endMs)) return;

    var activeEl = root.querySelector('[data-countdown-active]');
    var expiredEl = root.querySelector('[data-countdown-expired]');
    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');

    function render() {
      var diff = endMs - Date.now();

      if (diff <= 0) {
        if (activeEl) activeEl.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        return false;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (activeEl) activeEl.hidden = false;
      if (expiredEl) expiredEl.hidden = true;
      return true;
    }

    if (!render()) return;

    var interval = window.setInterval(function () {
      if (!render()) {
        window.clearInterval(interval);
      }
    }, 1000);

    root._sntCountdownInterval = interval;
  }

  function boot() {
    document.querySelectorAll('[data-snt-offer-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
